import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getDisplayTypeName } from "modules/analyze-historical-exposure/selectors/items"
import { getScreenName } from "modules/analyze-historical-exposure/selectors/file"
import { getSelectedDate } from "./dates"

export const getFileName = createSelector(
  [getPortfolioName, getSelectedDate, getViewType, getDisplayTypeName, getScreenName],
  (portfolioName, selectedDate, viewType, displayTypeName, screenName) =>
    `${portfolioName} ${capitalize(viewType)} ${displayTypeName} ${screenName} ${selectedDate}`,
)
